import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function DatasetIcon(props) {
    return (
        <SvgIcon {...props}>
            <g>
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-8 14H7v-4h4zm0-6H7V7h4zm6 6h-4v-4h4zm0-6h-4V7h4z"></path>
            </g>
        </SvgIcon>
    );
}

export default DatasetIcon;